function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103.54002,
    height: 59.38002,
    viewBox: "0 0 103.54002 59.380022",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-350.46999,-366.14999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 0.16,2.08 0.48,2.08 0.8,1.92 1.12,1.76 1.28,1.6 1.6,1.28 1.76,1.12 1.92,0.8 2.08,0.48 2.08,0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(355.04001,268.95999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 368.32001,282.39999 h 67.03998 V 14.72 h -67.03998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 0,0 -2.08,0.16 -2.08,0.48 -1.92,0.8 -1.76,1.12 -1.6,1.28 -1.28,1.6 -1.12,1.76 -0.8,1.92 -0.48,2.08 -0.16,2.08",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(368.32001,14.719995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M 354.88,28 V 268.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M 0,0 0.16,1.28 0.48,2.56 1.12,3.68 1.92,4.64 2.88,5.44 4,6.08 5.28,6.4 6.56,6.56",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(361.76001,268.95999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 368.32001,275.67999 h 13.44 V 21.280001 h -13.44",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M 0,0 -1.28,0.16 -2.56,0.48 -3.68,1.12 -4.64,1.92 -5.44,2.88 -6.08,4 -6.4,5.28 -6.56,6.56",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(368.32001,21.439996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 0,0 v 240.96001 m 20.16,6.71998 V -6.72 M 67.040001,147.36 H 26.879999 M 67.040001,93.760002 H 26.879999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(361.60001,27.999995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M 428.64001,21.280001 V 275.67999 h -40.16 V 21.280001 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 0,0 V -254.39999 M 6.72,0 V -254.39999 M 13.44,0 V -254.39999 M 20.16,0 V -254.39999 M 26.879999,0 V -254.39999 M 53.599998,-6.72 H 40.32 M 53.599998,-20 H 40.32 M 33.599998,-207.52 H -6.56 M 33.599998,-46.880001 H -6.56 m 0,141.119999 h -9.28",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(395.04001,275.67999)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 379.04001,369.92001 -0.64002,-0.96002 -0.96,-0.96002 -0.95999,-0.64001 -1.28,-0.47999 -1.12002,-0.32 -1.28,-0.16001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 372.79999,366.39999 h -14.72",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 0,0 -1.44,0.16 -2.88,0.64 -4.16,1.28 -5.28,2.08 -6.08,3.2 -6.72,4.48 -7.2,5.92 -7.36,7.36",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(358.07999,366.39999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 350.72,373.76001 v 44.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M 0,0 0.16,1.44 0.64,2.88 1.28,4.16 2.08,5.28 3.2,6.08 4.48,6.72 5.92,7.2 7.36,7.36",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(350.72,417.92001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 358.07999,425.28 h 14.72",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 372.79999,425.28 1.28,-0.16 1.12002,-0.32001 1.28,-0.47998 0.95999,-0.64002 0.95999,-0.95999 0.64002,-0.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m 379.20001,421.76001 h 9.28",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 388.48001,421.60001 1.75998,0.63998 L 392,422.72",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 392,422.88 4.32001,1.12 4.47998,0.64001 4.32001,0.47999 4.48001,0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 409.60001,425.28 4.47998,-0.16 4.32,-0.47999 L 422.88,424 l 4.32001,-1.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m 427.35999,422.72 3.52001,-1.11999 3.51999,-1.44001 3.36002,-1.6 3.19998,-2.07999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 440.79999,416.64001 2.08001,-1.44 1.76001,-1.6 L 446.39999,412 448,410.23999 l 1.44,-1.91998 1.28,-1.92002",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m 450.72,406.39999 0.95999,-1.6 0.80002,-1.75998 0.47998,-1.76001 0.48001,-1.76001 0.16001,-1.75998 0.16,-1.92001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 453.76001,395.84 -0.16,-1.91999 -0.16001,-1.76001 -0.48001,-1.76001 -0.47998,-1.75998 -0.80002,-1.76001 -0.95999,-1.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 450.72,385.28 -1.28,-1.92001 -1.44,-1.91999 -1.60001,-1.76001 -1.75998,-1.6 -1.76001,-1.59998 -2.08001,-1.44",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 440.95999,375.20001 -3.19998,-2.08001 -3.36002,-1.60001 -3.51999,-1.44 -3.52001,-1.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M 427.20001,368.95999 422.88,367.84 l -4.48001,-0.63999 -4.32,-0.48001 -4.47998,-0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 409.60001,366.56 -4.48001,0.16 -4.32001,0.48001 L 396.32001,367.84 392,368.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m 392,368.95999 -1.76001,0.48001 -1.75998,0.63999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 380.32001,408.79999 1.11999,0.80002 1.12,0.79998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m 382.56,410.39999 2.72,1.76001 2.72,1.28 3.04001,1.28 3.03998,0.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 394.07999,415.84 3.84002,0.95999 3.84,0.64001 3.84,0.32001 4,0.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 409.60001,417.92001 4,-0.16 3.83999,-0.32001 3.84,-0.64001 3.84,-0.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 425.28,415.67999 3.04001,-0.95999 3.03998,-1.28 2.72,-1.28 2.72,-1.76001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m 436.79999,410.39999 2.24002,-1.6 2.07999,-1.91999 1.76,-2.08001 1.60001,-2.23999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 444.48001,402.56 0.79999,-1.60001 0.64001,-1.6 0.31998,-1.75998 0.16,-1.76001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m 446.39999,395.84 -0.16,-1.76001 -0.31998,-1.75998 -0.64001,-1.60001 -0.79999,-1.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 444.48001,389.12 -1.60001,-2.24 -1.76,-2.08001 -2.07999,-1.91999 -2.24002,-1.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 436.79999,381.28 -2.72,-1.76001 -2.72,-1.28 -3.03998,-1.28 L 425.28,376",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m 425.12,376 -3.84,-0.95999 -3.84,-0.64002 -3.83999,-0.32 -4,-0.15998",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 409.60001,373.92001 -4,0.15998 -3.84,0.32 -3.84,0.64002 L 394.07999,376",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 394.07999,376 -3.03998,0.95999 -3.04001,1.28 -2.72,1.28 -2.72,1.76001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "m 382.56,381.28 -1.12,0.79999 -1.11999,0.80001",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "M 0,0 0.96,-0.16 1.92,-0.32 2.88,-0.8 3.68,-1.44 4.32,-2.24 4.8,-3.2 4.96,-4.16 5.12,-5.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(372.79999,423.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 372.79999,423.04001 h -14.72",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M 0,0 0.16,0.96 0.32,1.92 0.8,2.88 1.44,3.68 2.24,4.32 3.2,4.8 4.16,4.96 5.12,5.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(352.95999,417.92001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m 352.95999,417.92001 v -44.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M 0,0 -0.96,0.16 -1.92,0.32 -2.88,0.8 -3.68,1.44 -4.32,2.24 -4.8,3.2 -4.96,4.16 -5.12,5.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(358.07999,368.64001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 358.07999,368.64001 h 14.72",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "M 0,0 -0.16,-0.96 -0.32,-1.92 -0.8,-2.88 -1.44,-3.68 -2.24,-4.32 -3.2,-4.8 -4.16,-4.96 -5.12,-5.12",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(377.92001,373.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 378.07999,373.76001 v 44.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 380.16,373.76001 v -0.96002 l -0.32,-0.95999 -0.32001,-0.96 -0.47998,-0.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 380.16,373.76001 v 44.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 379.04001,421.76001 0.47998,-0.96002 0.32001,-0.95999 0.32,-0.96 v -0.95999",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 0,0 -1.6,1.44 -1.44,1.44 -1.28,1.76 -1.12,1.92 -0.64,1.92 -0.48,2.24 -0.16,2.08 0.16,2.08 0.48,2.240001 0.64,1.92 1.12,1.919998 1.28,1.76 L -1.6,24.16 0,25.6",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(439.20001,383.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 0,0 0.8,-0.16 0.8,-0.48 0.64,-0.64 0.32,-0.8 V -3.04 L 2.24,-3.84 1.6,-4.48 0.8,-4.96 0,-5.12 l -0.8,0.16 -0.8,0.48 -0.64,0.64 -0.32,0.8 v 0.96 l 0.32,0.8 0.64,0.64 0.8,0.48 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(365.44,398.39999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.53f49dcb5b542a27a14a5d7de791fd05.svg";
export { ForwardRef as ReactComponent };